/**
 * MODULAR module route manifest.
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE). The shell never knows about MODULAR pages beyond this file.
 */
export default {
  code: 'modular',
  routes: [
    {
      // Profil détaillé de l'utilisateur connecté (clic sur l'avatar du tiroir,
      // cf. NavigationService.goToPersonalProfil) : statique, donc accessible
      // sans droit sur le menu « Utilisateurs » du produit.
      path: '/modular-my-profile/:userId',
      name: 'modular-my-profile',
      component: () => import('@modular-pages/mod/modUserDetail.vue'),
      meta: { appCode: 'modular', myProfile: true, appCodes: ['modular'] }
    },
    {
      path: '/modular-portal',
      name: 'modular-portal',
      component: () => import('@modular-pages/portal/modular/modularPortal.vue'),
      meta: { appCode: 'modular', title: 'Modular' }
    },
    {
      path: '/architecture',
      name: 'modular-architecture',
      component: () => import('@modular-pages/portal/modular/modularArchitecture.vue'),
      meta: { appCode: 'modular', title: 'Architecture' }
    },
  ]
}
